var SCM = SCM || {};

SCM.AdobeAnalytics = (function ($) {
    return {
        sendAdobeAnalyticsProductData: _sendAdobeAnalyticsProductData,
        sendAdobeAnalyticsArticleData: _sendAdobeAnalyticsArticleData
    };

    function _sendAdobeAnalyticsProductData (articleId) {
        SCM.Ajax.get('/ThirdParty/GetAdobeAnalyticsProductDataForArticleAbstract', { articleId: articleId })
            .expectJson()
            .then(function (data) {
                digitalData.products.push({
                    productInfo: {
                        sku: data.SKU,
                        issueDate: data.IssueDate,
                        format: data.Format,
                        articleTitle: data.ArticleTitle,
                        abstractValues: data.AbstractValue,
                        societyName: data.SocietyName,
                        collectionName: data.CollectionName,
                        issue: data.Issue,
                        volume: data.Volume,
                        journalTitle: data.JournalTitle,
                        accensionNumber: data.AccensionNumber,
                        authors: data.Authors,
                        doi: data.Doi,
                        viewType: data.ViewType,
                        articleKeywords: data.ArticleKeywords,
                        articleMetadata: data.ArticleMetadata
                    }
                });
                _satellite.track('HTML Abstract View');
            })
            .catch(function (reason) {
                console.error('Error logging Adobe Analytics Product data', reason);
            });
    }

    function _sendAdobeAnalyticsArticleData(articleId, isAbstractPage, collectionId) {
        SCM.Ajax.get('/ThirdParty/GetAdobeAnalyticsProductDataForArticlePage', { articleId: articleId, isAbstractPage: isAbstractPage, collectionId: collectionId })
            .expectJson()
            .then(function (data) {
                digitalData.products.push({
                    productInfo: {
                        sku: data.SKU,
                        issueDate: data.IssueDate,
                        format: data.Format,
                        articleTitle: data.ArticleTitle,
                        abstractValues: data.AbstractValue,
                        societyName: data.SocietyName,
                        collectionName: data.CollectionName,
                        issue: data.Issue,
                        volume: data.Volume,
                        journalTitle: data.JournalTitle,
                        accensionNumber: data.AccensionNumber,
                        authors: data.Authors,
                        doi: data.Doi,
                        viewType: data.ViewType,
                        articleKeywords: data.ArticleKeywords,
                        articleMetadata: data.ArticleMetadata
                    }
                });
                _satellite.track('HTML Full Text View');
            })
            .catch(function (reason) {
                console.error('Error logging Adobe Analytics Product data', reason);
            });
    }
})(jQuery);

// If we are in a module context, export this module (required for unit test)
'object' === typeof module && module.exports && (module.exports = SCM.AdobeAnalytics);